import { IUserProfileLocalRepository, CustomError, UserProfile } from "../../index";

export class SetLocalUserMeetTheTeamCompletedUseCase {
    private localRepository: IUserProfileLocalRepository;

    constructor(localRepository: IUserProfileLocalRepository) {
        this.localRepository = localRepository;
    }

    execute(): UserProfile | CustomError {
        return this.localRepository.setMeetTheTeamCompleted();
    }
}